<template>
    <svg xmlns="http://www.w3.org/2000/svg"
         :width="width"
         :height="height"
         :viewBox="viewBox"
         :aria-labelledby="iconName"
         :fill="iconColor"
         role="presentation">
        <title :id="iconName"
               lang="en">{{ iconName }} icon</title>
        <slot />
    </svg>
</template>

<script>
export default {
    props: {
        iconName: {
            type: String,
            default: 'box'
        },
        width: {
            type: [Number, String],
            default: 20
        },
        height: {
            type: [Number, String],
            default: 20
        },
        viewBox: {
            type: String,
            default: "0 0 20 20",
        },
        iconColor: {
            type: String,
            default: 'none'
        }
    }
};
</script>

<style scoped>
svg {
    display: inline-block;
    vertical-align: baseline;
}
</style>